import { addCollection, type IconifyJSON } from 'iconify-icon';

export function importIcons() {
  const modules = import.meta.glob('../../json/*.json', { eager: true });
  for (const module of Object.values(modules)) {
    addCollection(module as IconifyJSON);
  }
}
